import Carousel from "react-spring-3d-carousel";
import { useState, useEffect } from "react";
import { config } from "react-spring";
import { Button } from "../ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Carroussel(props: any) {
  const table =
    props.cards &&
    props.cards.map((element: any, index: any) => {
      return { ...element, onClick: () => setGoToSlide(index) };
    });

  const [offsetRadius, setOffsetRadius] = useState(2);
  const [showArrows, setShowArrows] = useState(false);
  const [goToSlide, setGoToSlide] = useState<number | undefined>(undefined);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    setOffsetRadius(props.offset);
    setShowArrows(props.showArrows);
  }, [props.offset, props.showArrows]);

  const nextSlide = () => {
    const nextIndex = (currentSlide + 1) % table.length;
    setCurrentSlide(nextIndex);
    setGoToSlide(nextIndex);
    if (props.onSlideChange) {
      props.onSlideChange(nextIndex);
    }
  };

  const PrevSlide = () => {
    const nextIndex = (currentSlide - 1 + table.length) % table.length;
    setCurrentSlide(nextIndex);
    setGoToSlide(nextIndex);

    if (props.onSlideChange) {
      props.onSlideChange(nextIndex);
    }
  };

  return (
    <div
      style={{ width: props.width, height: props.height, margin: props.margin }}
    >
      <Carousel
        slides={table}
        goToSlide={goToSlide}
        offsetRadius={offsetRadius}
        showNavigation={false}
        animationConfig={config.gentle}
      />
      <div className="flex justify-center ">
        <Button
          variant="outline"
          size="icon"
          className="bg-primary group"
          onClick={PrevSlide}
        >
          <ChevronLeft className="w-4 h-4 text-white next group-hover:text-black" />
        </Button>
        <Button
          variant="outline"
          size="icon"
          className="bg-primary group"
          onClick={nextSlide}
        >
          <ChevronRight className="w-4 h-4 text-white back group-hover:text-black" />
        </Button>
      </div>
    </div>
  );
}
